// eslint-disable-next-line architecture/no-local-react-state -- Canvas boundary reports actual DOM mount/unmount; the viewer module owns rendering work.
import { CSSProperties, useEffect, useId } from 'react'
import type { DocumentViewerSend } from '../../document-viewer'

type Props = {
  send: DocumentViewerSend
  pageNumber: number
  className?: string
  width: number
  height: number
  style?: CSSProperties
}

export function CanvasImage({ send, pageNumber, className, width, height, style }: Props) {
  const reactCanvasId = useId()
  const canvasId = `dvk-canvas-${reactCanvasId.replace(/:/g, '')}`

  useEffect(() => {
    send({
      type: 'pageSurfaceMounted',
      pageNumber,
      surfaceId: canvasId
    })
    return () => {
      send({
        type: 'pageSurfaceUnmounted',
        pageNumber,
        surfaceId: canvasId
      })
    }
  }, [send, pageNumber, canvasId])

  return <canvas id={canvasId} width={width} height={height} style={style} className={className} />
}
